import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=38a1a8c0&lang=pug&"
import script from "./detail.vue?vue&type=script&setup=true&lang=js&"
export * from "./detail.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./detail.vue?vue&type=style&index=0&id=38a1a8c0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports